import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { TealiumAnalyticsEvent, TealiumAnalyticsService } from '@ddt-web/analytics';
import { timer } from 'rxjs';
import { first } from 'rxjs/operators';

@Component({
	selector: 'ac-tips',
	templateUrl: './tips.component.html',
	styleUrls: ['./tips.component.scss']
})
export class TipsComponent implements OnChanges {

	@Input() public tipsPrefixes: Array<string>;

	public numberOfTips: number;
	public currentTipIndex: number;

	@ViewChild('slider', { static: false }) private sliderElement: ElementRef<HTMLDivElement>;

	constructor(private tealiumAnalyticsService: TealiumAnalyticsService) { }

	public ngOnChanges(changes: SimpleChanges): void {
		this.numberOfTips = this.tipsPrefixes.length;
		this.currentTipIndex = 0;
		this.slideToPage(0, false);
	}

	public slideToPage(newPageIndex: number, trackPage: boolean = true): void {
		// Set the new index
		if (newPageIndex >= 0 && newPageIndex < this.numberOfTips) {
			this.currentTipIndex = newPageIndex;
		}
		if (trackPage) {
			this.tealiumAnalyticsService.trackEventTealium(new TealiumAnalyticsEvent('tips-component:change-page:' + this.tipsPrefixes[this.currentTipIndex], null));
		}

		if (this.sliderElement?.nativeElement) {
			// Animate to the new page
			this.sliderElement.nativeElement.classList.add('is-animating');
			const currentSlidePercentage = -(100 / this.numberOfTips) * this.currentTipIndex;
			this.sliderElement.nativeElement.style.transform = `translateX(${currentSlidePercentage}%)`;

			timer(400).pipe(first()).subscribe(() => {
				this.sliderElement.nativeElement.classList.remove('is-animating');
			});
		}
	}

	public onPan(event): void {
		if (event.pointerType === 'touch') {
			// Swiping over images doesn't work correctly with a mouse as the images are draggable, 
			// so we only respond to touch
			const pageSlidePercentageThreshold = 25;

			// Calculate how much we have panned
			const panPercentage = (100 / this.numberOfTips) * (event.deltaX / window.innerWidth);
			// Work out how much more we need to move the slider to match
			const sliderPercentage = panPercentage - ((100 / this.numberOfTips) * this.currentTipIndex);
			this.sliderElement.nativeElement.style.transform = `translateX(${sliderPercentage}%)`;

			// Check if the swipe went far enough to trigger the next page
			if (event.isFinal) {
				if (panPercentage <= -(pageSlidePercentageThreshold / this.numberOfTips)) {
					this.slideToPage(this.currentTipIndex + 1);
				}
				else if (panPercentage >= (pageSlidePercentageThreshold / this.numberOfTips)) {
					this.slideToPage(this.currentTipIndex - 1);
				}
				else {
					this.slideToPage(this.currentTipIndex);
				}

			}
		}
	}

}
